import { Component, ReactNode } from 'react';

type OnClose = () => void;
type OnUpload = (src: string, file: File) => void;

interface IProps {
  children: (props: IUploader) => ReactNode;
}

interface IState {
  open: boolean;
  src: string;
  file: File;
}

export interface IUploader {
  open: IState['open'];
  onClose: OnClose;
  onUpload: OnUpload;
  data: {
    src: IState['src'];
    file: IState['file'];
  };
}

class Uploader extends Component<IProps, IState> {
  state: IState = {
    open: false,
    src: null,
    file: null,
  };

  onClose: OnClose = () => {
    this.setState({ open: false });
  };

  onUpload: OnUpload = (src, file) => {
    this.setState({ src, file, open: true });
  };

  render() {
    const { open, file, src } = this.state;

    const props: IUploader = {
      open,
      onClose: this.onClose,
      onUpload: this.onUpload,
      data: { file, src },
    };

    return this.props.children(props);
  }
}

export default Uploader;
